module.exports = __webpack_public_path__ + "static/img/solu5.39551f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu5.png
// module id = uw3Y
// module chunks = 1